import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { EditFnaStepComponent } from '../../editFnaPage/types';
import { FnaPolicyStructure } from '../../../common/types/analyses';
import { JSX } from 'react';
import { Option } from '../../../common/types/option';
import { useQuery } from '@tanstack/react-query';

// Map of structure description descriptions
const StructureDescriptionsMap: Record<FnaPolicyStructure, string> = {
  [FnaPolicyStructure.Traditional]:
    'Multiple applicants on each policy pro-rata to their ownership in the business and on a single insured life only.',
  [FnaPolicyStructure.Alternative]:
    'One applicant per policy whereby a portion of the cover on the other owner`s lives is applied for.',
  [FnaPolicyStructure.ShareBuyBack]:
    'Business is policy owner for full amount of cover required on each shareholder/member. Only allowed for companies.',
};

/**
 * Step with FNA's buy and sell structure type selector
 */
const StructureStep: EditFnaStepComponent = ({ control }) => {
  const { data: structures } = useQuery<Option[]>({
    queryKey: ['/FNABuyandsellPolicyStructures'],
  });

  if (!structures) {
    return (
      <Box className="space-y-8">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" height={50} />
        ))}
      </Box>
    );
  }

  return (
    <Controller
      name="buyandsell.policyStructureID"
      control={control}
      render={({ field }): JSX.Element => (
        <FormControl>
          <RadioGroup className="space-y-8" {...field} value={field.value || null}>
            {structures.map((structure) => (
              <FormControlLabel
                key={structure.id}
                value={structure.id}
                control={<Radio />}
                label={
                  <Box>
                    <Typography fontWeight={700}>{structure.note}</Typography>
                    <Typography>
                      {StructureDescriptionsMap[structure.id as FnaPolicyStructure]}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

export default StructureStep;
